import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import Swal from 'sweetalert2';
import { CaptchaComponent } from '../captcha/captcha.component';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { CadastroHelprev } from '../model/cadastro-helprev';
import { CadastroHelprevService } from '../service/cadastro-helprev.service';
import { CookieService } from 'ngx-cookie';
import { fixedValues, fieldList } from 'src/environments/mapping-fields';
import { DOCUMENT } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent  implements OnInit {
  testCadastro = { "title": "asfdasdfasdf", "description": "sdfa sdfads fads fasd fasd f adsfas df", "CustomColumn282sr": new Date().toISOString().slice(0,16), "CustomColumn288sr": "teste local relato", "CustomColumn277sr": "teste ponto de referencia", "CustomColumn275sr": "teste empresa envolvida", "CustomColumn284sr": "teste aeronave", "CustomColumn279sr": "teste equipamento", "CustomColumn233sr": "teste observações", "CustomColumn273sr": "teste autor do relat", "CustomColumn274sr": "teste email do autor", "CustomColumn278sr": "teste empresa do autor" };
  testCadastroHomolog = { "title": "asfdasdfasdf", "description": "sdfa sdfads fads fasd fasd f adsfas df", "CustomColumn1269sr": new Date().toISOString().slice(0,16), "CustomColumn1282sr": "teste local relato", "CustomColumn1273sr": "teste ponto de referencia", "CustomColumn1274sr": "teste empresa envolvida", "CustomColumn1275sr": "teste aeronave", "CustomColumn1276sr": "teste equipamento", "CustomColumn233sr": "teste observações", "CustomColumn1277sr": "teste autor do relat", "CustomColumn1278sr": "teste email do autor", "CustomColumn1279sr": "teste empresa do autor" };

  @ViewChild('captcha') captchaComponent!: CaptchaComponent;
  @ViewChild('fileUpload') fileUploadComponent!: FileUploadComponent;

  frmFieldList = fieldList.filter(field => !field.search);

  frmCadastro: FormGroup = new FormGroup({});
  cadastroHelprev = new CadastroHelprev();
  successMessage!: any;
  errorMessage!: any;
  isClicked: boolean = false;


  constructor(private fb: FormBuilder,
    private cadastroHelprevService: CadastroHelprevService,
    private translate: TranslateService,
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: Document) {

      this.createFrmCadastro();

    }

  ngOnInit(): void {
    // this.frmCadastro.patchValue(this.testCadastroHomolog);

    this.translate.get('Mensagem Sucesso')
      .subscribe(res => this.successMessage = res);

    this.cadastroHelprevService.validateSession().pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.cookieService.put('JSESSIONID',response.validate);
        },
        error: (erro: any) => {
          console.error('erro', erro)
        }
      })
  }

  createFrmCadastro() {
    fieldList.forEach((obj: any) => {
      this.frmCadastro.addControl(obj.field, new FormControl('', obj.required ? [Validators.required] : []));
    });
  }

  get f() {
    return this.frmCadastro.controls;
  }

  onSubmit() {
    this.isClicked = true;
    this.frmCadastro.markAllAsTouched();
    if (this.frmCadastro.invalid) {
      this.translate.get('Campos não preenchidos')
        .subscribe(res => Swal.fire('', res, 'error'))
        this.isClicked=false;
      return;
    }

    if (this.captchaComponent.captchaCode.toUpperCase() !== this.captchaComponent.userInputCaptcha.toUpperCase()) {
      this.translate.get('CAPTCHA incorreto')
        .pipe(take(1))
        .subscribe(res => Swal.fire('', res, 'error'))

      this.captchaComponent.generateCaptcha();
      this.isClicked=false;
      return;
    }


    this.cadastroHelprev.info = Object.assign([], fixedValues);

    fieldList.filter((obj: any) => obj.type == 'datetime-local').forEach((obj:any) => {
      let dateString = this.frmCadastro.controls[obj.field].value!.toString();
      this.frmCadastro.controls[obj.field].setValue(new Date(dateString).getTime().toString());
    });

    Object.keys(this.frmCadastro.controls).forEach(key => {
      this.cadastroHelprev.info.push({ key: key, value: this.frmCadastro.get(key)?.value })
    });

    this.cadastroHelprevService.sendRequest(this.cadastroHelprev).pipe(take(1))
      .subscribe({
        next: (res) => {
          this.fileUploadComponent.sendUploadedFiles(res.id);
          Swal.fire('', this.replaceMessage(res, this.frmCadastro), 'success').then(() => {
            this.frmCadastro.reset();
            this.fileUploadComponent.resetField();
            this.captchaComponent.userInputCaptcha = '';
            this.isClicked=false;
          });
        },
        error: (erro) => {
          Swal.fire('', erro.message, 'error');
          this.isClicked=false;
          console.log('erro', erro)
        } 
      })
  }

  replaceMessage(res: any, frmCadastro: FormGroup){
    let urlStr = this.document.location.origin + this.document.location.pathname + '#/search/' + res.id;
    let dataFormatada = res.info.filter((item:any) => item.key === 'insert_time')[0].valueCaption;

    return this.successMessage.replace('[ID]', res.id).replace('[DATA]', dataFormatada).replaceAll('[URL]', urlStr )
  }

}
